export type AwsMetadataQueryParams = {
  domain?: string
  teamId: string
  mode?: string
}

export const awsMetadataQueryKeys = {
  getAutoscalingGroupsMetadata: (params: AwsMetadataQueryParams) =>
    ['aws/metadata/autoscaling-groups', params] as const,
  getIamRoleMetadata: (teamId: string) =>
    ['aws/metadata/iam-role', { teamId }] as const,
  getLoadBalancersMetadata: (params: AwsMetadataQueryParams) =>
    ['aws/metadata/load-balancers', params] as const
}
